import {
  Button,
  Card,
  ListItem,
  Typography,
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
  TableContainer,
  TablePagination,
  useTheme,
  TableSortLabel,
  IconButton,
  makeStyles,
  lighten,
  Paper,
  withStyles,
  TableFooter,
  CircularProgress,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  AccordionActions,
  Fade,
  TextField,
} from "@material-ui/core";
import React, { useState, useEffect, useContext } from "react";
import OwnerHeader from "../Components/OwnerHeader";
import { KeyboardDatePicker } from "@material-ui/pickers";
import moment from "moment";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import { useHistory, useParams } from "react-router-dom";
import { Instance } from "../../../Config";
import CustomSnakBar from "../../../Components/CustomSnakBar";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { CSVLink } from "react-csv";
import GlobalContext from "../../../Context/globalContext";

import InsertDriveFileOutlinedIcon from "@material-ui/icons/InsertDriveFileOutlined";
import SaveAltIcon from "@material-ui/icons/SaveAlt";
import FilterListIcon from "@material-ui/icons/FilterList";
import { SHOW_SNACKBAR } from "../../../Context/globalActions.types";
import { Autocomplete, Skeleton } from "@material-ui/lab";
import AddIcon from "@material-ui/icons/Add";
import useSWR from "swr";

const useStyles = makeStyles((theme) => ({
  fullWidth: {
    width: "100%",
  },
  paper: {
    width: "100%",
    marginBottom: theme.spacing(2),
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
  highlight:
    theme.palette.type === "light"
      ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark,
        },
  title: {
    flex: "1 1 100%",
  },
}));

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(even)": {
      backgroundColor: "#FBFBFB",
    },
    "&:hover": {
      backgroundColor: "#F3F3F3",
      transform: "scale(1.0019)",
    },
  },
}))(TableRow);

const useStyles1 = makeStyles((theme) => ({
  root: {
    flexShrink: 0,
    marginLeft: theme.spacing(2.5),
  },
}));

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

export default function LocationReport() {
  const classes = useStyles();
  const { globalContext, dispatch } = useContext(GlobalContext);
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("CREATED_AT");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [filterSman, setFilterSman] = useState([]);
  const [formValue, setFormValue] = useState({
    smanCd: "",
    smanName: "",
    fromDate: moment().subtract(1, "month").format("YYYY-MM-DD hh:mm:ss"),
    toDate: moment().format("YYYY-MM-DD hh:mm:ss"),
  });

  const [showFilters, setShowFilters] = useState(false);

  const { data: resSmanFilter, error: resSmanFilterError } =
    useSWR("/location/filter");

  const fetchData = () => {
    setIsLoading(true);
    Instance.get(
      `/reports/locations?cd=${formValue.smanCd}&fromDate=${formValue.fromDate}&toDate=${formValue.toDate}`
    )
      .then((res) => {
        if (res) {
          setIsLoading(false);
          setRows(res.data.result);
        }
      })
      .catch(() => {
        dispatch({
          type: SHOW_SNACKBAR,
          payload: {
            message: "Something went wrong",
            type: "error",
          },
        });
      });
  };

  const handleFromDateChange = (date) => {
    setFormValue({
      ...formValue,
      fromDate: moment(date).format("YYYY-MM-DD hh:mm:ss"),
    });
  };

  const handleToDateChange = (date) => {
    setFormValue({
      ...formValue,
      toDate: moment(date).format("YYYY-MM-DD hh:mm:ss"),
    });
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const [exportCsv, setExportCsv] = useState(false);
  const headers = [
    { label: "Sr No", key: "id" },
    { label: "Cd", key: "USER_CD" },
    { label: "Date", key: "VOUCH_DT" },
    { label: "Time", key: "VOUCH_TIME" },
    { label: "Name", key: "sman.SMAN_NAME" },
    { label: "Status", key: "REMARK" },
  ];

  const exportPdf = () => {
    const unit = "pt";
    const size = "A4";
    const orientation = "portrait";

    const marginLeft = 40;
    const doc = new jsPDF(orientation, unit, size);

    doc.setFontSize(15);

    const title = "Location Report";
    const headers = [["Sr No", "Cd", "Date", "Time", "Name", "Status"]];

    const data = rows.map((e, index) => [
      index + 1,
      e.USER_CD,
      e.VOUCH_DT,
      e.VOUCH_TIME,
      e.sman.SMAN_NAME,
      e.REMARK,
    ]);

    let content = {
      startY: 70,
      head: headers,
      body: data,
    };

    let width1 = doc.internal.pageSize.getWidth();

    doc.setFontSize(14).setFont(undefined, "bold");
    doc
      .text(globalContext.company[0].COMP_NAME, width1 / 2, 20, {
        align: "center",
      })
      .setFontSize(8)
      .setFont(undefined, "bold");
    doc.text(globalContext.company[0].ADDRS, width1 / 2, 38, {
      align: "center",
    });
    doc.text(
      `From Date: ${moment(formValue.fromDate).format(
        "DD-MM-YYYY"
      )} To: ${moment(formValue.toDate).format("DD-MM-YYYY")} Name: ${
        formValue.smanName
      }`,
      width1 / 2,
      60,
      {
        align: "center",
      }
    );
    doc.autoTable(content);
    doc.save("LocationReport.pdf");
  };

  const [headCells, setHeadCells] = useState([
    {
      id: "id",
      label: "Sr No",
    },
    {
      id: "USER_CD",
      label: "Cd",
    },
    {
      id: "VOUCH_DT",
      label: "Date",
    },
    {
      id: "VOUCH_TIME",
      label: "Time",
    },
    {
      id: "SMAN_NAME",
      label: "Name",
    },
    {
      id: "REMARK",
      label: "Status",
    },
  ]);

  function EnhancedTableHead(props) {
    const { classes, order, orderBy, onRequestSort } = props;

    const createSortHandler = (property) => (event) => {
      onRequestSort(event, property);
    };

    return (
      <TableHead className="sticky top-0">
        <TableRow
          className={`grid grid-cols-3 pb-1 md:grid-cols-${
            headCells.length + 2
          } md:mx-3 md:bg-white bg-gray-200`}
        >
          {headCells.map((headCell) => (
            <TableCell
              key={headCell.id}
              align="left"
              className={`font-bold border-0 pt-0 pr-[24px] pb-0 pl-[9px] text-[12px] leading-5 w-max bg-transparent`}
              padding={headCell.disablePadding ? "none" : "normal"}
              sortDirection={orderBy === headCell.id ? order : false}
            >
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : "asc"}
                onClick={createSortHandler(headCell.id)}
              >
                {headCell.label}
                {orderBy === headCell.id ? (
                  <span className={classes.visuallyHidden}>
                    {order === "desc"
                      ? "sorted descending"
                      : "sorted ascending"}
                  </span>
                ) : null}
              </TableSortLabel>
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
    );
  }

  function TablePaginationActions(props) {
    const classes = useStyles1();
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleBackButtonClick = (event) => {
      onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
      onPageChange(event, page + 1);
    };

    return (
      <div className={classes.root}>
        <IconButton
          onClick={handleBackButtonClick}
          disabled={page === 0}
          aria-label="previous page"
        >
          {theme.direction === "rtl" ? (
            <KeyboardArrowRight />
          ) : (
            <KeyboardArrowLeft />
          )}
        </IconButton>
        <IconButton
          onClick={handleNextButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="next page"
        >
          {theme.direction === "rtl" ? (
            <KeyboardArrowLeft />
          ) : (
            <KeyboardArrowRight />
          )}
        </IconButton>
      </div>
    );
  }

  useEffect(() => {
    if (resSmanFilter) {
      setFilterSman(resSmanFilter.data.result);
    }
  }, [resSmanFilter]);

  useEffect(() => {
    if (resSmanFilterError) {
      dispatch({
        type: SHOW_SNACKBAR,
        payload: {
          message: "Something went wrong",
          type: "error",
        },
      });
    }
  }, [resSmanFilterError]);

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <OwnerHeader>
      <div className="md:flex items-center justify-between px-3 md:px-4 py-3">
        <div>
          <div className="text-indigo-500 font-semibold text-sm md:text-base">
            Reporting
          </div>
          <div className="text-xl md:text-2xl font-extrabold leading-7 sm:leading-10 truncate mt-1">
            Location Summary
          </div>
        </div>
      </div>
      <div className="py-1 min-h-screen bg-[#F1F5F9] px-2">
        <Card className="mb-4 shadow-sm">
          <ListItem className="pb-0">
            <div className="flex items-center justify-between w-full">
              <div className="flex items-center">
                <FilterListIcon className="text-indigo-500" />
                <Typography
                  variant="h6"
                  className="text-indigo-500 uppercase font-bold tracking-wider text-xs ml-2"
                >
                  Advanced Filters
                </Typography>
              </div>
              <Button size="small" onClick={() => setShowFilters(!showFilters)}>
                {showFilters ? "Hide" : "Show"}
              </Button>
            </div>
          </ListItem>
          {showFilters && (
            <div className="px-4 pb-4">
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3 mb-3">
                {window.innerWidth < 600 ? (
                  <KeyboardDatePicker
                    margin="normal"
                    id="date-picker-dialog"
                    label="From"
                    format="DD/MM/yyyy"
                    value={formValue.fromDate}
                    onChange={handleFromDateChange}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                    className="bg-white"
                  />
                ) : (
                  <KeyboardDatePicker
                    disableToolbar
                    variant="inline"
                    format="DD/MM/yyyy"
                    margin="normal"
                    id="date-picker-inline"
                    label="From"
                    value={formValue.fromDate}
                    onChange={handleFromDateChange}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                    className="bg-white"
                  />
                )}
                {window.innerWidth < 600 ? (
                  <KeyboardDatePicker
                    margin="normal"
                    id="date-picker-dialog"
                    label="To"
                    format="DD/MM/yyyy"
                    value={formValue.toDate}
                    onChange={handleToDateChange}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                    className="bg-white"
                  />
                ) : (
                  <KeyboardDatePicker
                    disableToolbar
                    variant="inline"
                    format="DD/MM/yyyy"
                    margin="normal"
                    id="date-picker-inline"
                    label="To"
                    value={formValue.toDate}
                    onChange={handleToDateChange}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                    className="bg-white"
                  />
                )}
                <Autocomplete
                  id="Sman-report"
                  autoHighlight
                  options={filterSman}
                  getOptionLabel={(option) => option.SMAN_NAME}
                  renderOption={(option) => (
                    <React.Fragment>
                      {option.SMAN_NAME}({option.SMAN_CD})
                    </React.Fragment>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      size="small"
                      label="Select User"
                      margin="normal"
                      className="bg-white"
                    />
                  )}
                  onChange={(_, value) => {
                    if (value) {
                      setFormValue({
                        ...formValue,
                        smanCd: value.SMAN_CD,
                        smanName: value.SMAN_NAME,
                      });
                    }
                  }}
                />
              </div>
              <div className="flex justify-end">
                <Button
                  variant="contained"
                  disableElevation
                  className="bg-[#3333cc] text-white"
                  onClick={fetchData}
                >
                  Apply Filters
                </Button>
              </div>
            </div>
          )}
        </Card>
        {/* <Accordion>
          <AccordionSummary
            expandIcon={<AddIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography className={classes.heading}>Accordion 1</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit.
              Suspendisse malesuada lacus ex, sit amet blandit leo lobortis
              eget.
            </Typography>
          </AccordionDetails>
          <AccordionActions>
            <Button size="small">Cancel</Button>
            <Button size="small" color="primary">
              Save
            </Button>
          </AccordionActions>
        </Accordion> */}
        <React.Fragment>
          <TableContainer
            component={Paper}
            style={{
              overflowX: "clip",
            }}
          >
            <div className="md:flex justify-between w-full mt-3 mb-2 px-2 pt-3">
              <Typography className="md:ml-2 text-md md:text-lg mb-2 font-medium">
                Location Report
              </Typography>
              <div>
                <Button
                  variant="outlined"
                  className="text-blue-600 border-[#3333cc] mt-2 md:mt-0"
                  startIcon={<SaveAltIcon />}
                >
                  <CSVLink
                    data={rows}
                    headers={headers}
                    filename="OrdersReport.csv"
                    className="text-blue-600"
                  >
                    Excel
                  </CSVLink>
                </Button>
                <Button
                  variant="outlined"
                  className="text-blue-600 border-[#3333cc] mt-2 md:mt-0 ml-2"
                  startIcon={<InsertDriveFileOutlinedIcon />}
                  onClick={() => {
                    exportPdf();
                  }}
                >
                  PDF
                </Button>
              </div>
            </div>
            <div className="max-h-screen overflow-x-hidden">
              {globalContext.settings.length !== 0 ? (
                <Table stickyHeader>
                  {headCells.length === 0 ? null : (
                    <EnhancedTableHead
                      classes={classes}
                      order={order}
                      orderBy={orderBy}
                      onRequestSort={handleRequestSort}
                      rowCount={rows ? rows.length : null}
                    />
                  )}
                  <TableBody>
                    {isLoading && rows.length === 0 ? (
                      <StyledTableRow
                        className={`grid grid-cols-3 py-1 items-center md:grid-cols-${
                          headCells.length + 2
                        } md:mx-3`}
                      >
                        <StyledTableCell className="border-0 pt-0 pr-[24px] pb-0 pl-[9px] text-[12px] leading-4">
                          <Skeleton />
                        </StyledTableCell>
                        <StyledTableCell className="border-0 pt-0 pr-[24px] pb-0 pl-[9px] text-[12px] leading-4">
                          <Skeleton />
                        </StyledTableCell>
                        <StyledTableCell className="border-0 pt-0 pr-[24px] pb-0 pl-[9px] text-[12px] leading-4">
                          <Skeleton />
                        </StyledTableCell>
                        <StyledTableCell className="border-0 pt-0 pr-[24px] pb-0 pl-[9px] text-[12px] leading-4">
                          <Skeleton />
                        </StyledTableCell>
                      </StyledTableRow>
                    ) : !isLoading && rows.length == 0 ? (
                      <TableRow hover tabIndex={-1}>
                        <TableCell align="center" colSpan={6}>
                          No Data Found
                        </TableCell>
                      </TableRow>
                    ) : (
                      stableSort(rows, getComparator(order, orderBy))
                        .slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage
                        )
                        .map((row, index) => {
                          return (
                            <StyledTableRow
                              key={row.locId}
                              className={`grid grid-cols-3 py-1 items-center md:grid-cols-${
                                headCells.length + 2
                              } md:mx-3 border-t-[1px] hover:font-semibold cursor-pointer`}
                            >
                              <StyledTableCell
                                align="left"
                                style={{
                                  fontWeight: "inherit",
                                }}
                                className="border-0 pt-0 pr-[24px] pb-0 pl-[9px] text-[12px] leading-4"
                              >
                                {index + 1}
                              </StyledTableCell>
                              <StyledTableCell
                                align="left"
                                style={{
                                  fontWeight: "inherit",
                                }}
                                className="border-0 pt-0 pr-[24px] pb-0 pl-[9px] text-[12px] leading-4"
                              >
                                {row.USER_CD ? row.USER_CD : ""}
                              </StyledTableCell>
                              <StyledTableCell
                                align="left"
                                style={{
                                  fontWeight: "inherit",
                                }}
                                className="border-0 pt-0 pr-[24px] pb-0 pl-[9px] text-[12px] leading-4"
                              >
                                {row.VOUCH_DT ? row.VOUCH_DT : ""}
                              </StyledTableCell>
                              <StyledTableCell
                                align="left"
                                style={{
                                  fontWeight: "inherit",
                                }}
                                className="border-0 pt-0 pr-[24px] pb-0 pl-[9px] text-[12px] leading-4"
                              >
                                {row.VOUCH_TIME ? row.VOUCH_TIME : ""}
                              </StyledTableCell>
                              <StyledTableCell
                                align="left"
                                style={{
                                  fontWeight: "inherit",
                                }}
                                className="border-0 pt-0 pr-[24px] pb-0 pl-[9px] text-[12px] leading-4"
                              >
                                {row.sman ? row.sman.SMAN_NAME : ""}
                              </StyledTableCell>
                              <StyledTableCell
                                align="left"
                                style={{
                                  fontWeight: "inherit",
                                }}
                                className="border-0 pt-0 pr-[24px] pb-0 pl-[9px] text-[12px] leading-4"
                              >
                                {row.REMARK ? row.REMARK : ""}
                              </StyledTableCell>
                            </StyledTableRow>
                          );
                        })
                    )}
                  </TableBody>
                  <TablePagination
                    rowsPerPageOptions={[25, 50, 100]}
                    component={Paper}
                    count={rows ? rows.length : null}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    ActionsComponent={TablePaginationActions}
                    elevation={0}
                  />
                </Table>
              ) : null}
            </div>
          </TableContainer>
        </React.Fragment>
      </div>
    </OwnerHeader>
  );
}
